import { Link } from "react-router-dom";

export const FloatingL = () => (
  <Link
    to="/learning-licence-prep"
    data-testid="floating-l-btn"
    aria-label="Learning Licence Preparation"
    className="group fixed bottom-[92px] right-4 z-[59] flex h-14 w-14 -rotate-6 items-center justify-center rounded-2xl border-2 border-dwc-crimson bg-white shadow-[0_12px_32px_rgba(181,18,43,0.3)] transition-transform duration-300 hover:-translate-y-1 hover:rotate-0 md:bottom-24 md:right-6"
  >
    <span className="absolute inset-0 animate-ping rounded-2xl border-2 border-dwc-crimson/40 [animation-duration:2.5s]" aria-hidden="true" />
    <span className="text-3xl font-black leading-none text-dwc-crimson">L</span>
    <span className="pointer-events-none absolute -top-9 right-0 hidden whitespace-nowrap rounded-lg bg-dwc-charcoal px-3 py-1.5 text-[10px] font-extrabold uppercase tracking-wide text-white opacity-0 transition-opacity duration-200 group-hover:opacity-100 md:block" aria-hidden="true">
      Learning Licence Prep
    </span>
  </Link>
);
